// frontend/src/hooks/useClinicName.ts
import { useClinicInfo } from '../services/api';

/**
 * Hook for getting clinic name to use in page titles
 */
export const useClinicName = (): string => {
  const { data: clinicInfo } = useClinicInfo();
  return clinicInfo?.[0]?.name || 'Elit-Med';
};
